import urls from "api/urls";
import wagoNavLooperBG from "Asset/Images/wagoNavLooperBG.png";
import wagoLogoSidebar from "Asset/Images/wagoW.png";
import LooperWAGO from "Asset/LooperWAGO.png";
import LooperWAGOCropped from "Asset/LooperWAGOCropped.png";
import wagoLogoMain from "Asset/WAGO.png";
import { defaultLoginLayout } from "design-system/strategies/loginLayout";

export const wagoTheme = {
  clientDisplayName: "Wago",

  favicon: "/wagoFavicon.ico",

  fonts: {
    heading: "WAGO Connective",
    primary: "WAGO Connective",
  },

  links: {
    website: urls.redirects.clientWebsite,
  },

  login: {
    layout: defaultLoginLayout,
    particles: undefined,
  },

  logo: {
    alt: "Wago",
    href: urls.redirects.clientWebsite,
    mainSrc: wagoLogoMain,
    sidebarSrc: wagoLogoSidebar,
  },

  logoLooper: {
    croppedSrc: LooperWAGOCropped,
    lgSrc: LooperWAGO,
  },

  name: "wago",

  navLooper: {
    src: wagoNavLooperBG,
  },
};
